export default __webpack_public_path__ + "static/media/pitchnet3.63f29a01.mp4";